// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604091638/js/" + chunkId + "." + {"44":"2d44b621","225":"1e4ab7d5","481":"4ecb5f60","486":"f55816e6","770":"b833ee7d"}[chunkId] + ".0.8322258191930902.chunk.js";
};